import { DateHelper } from '@bryntum/scheduler';
import { isDateGreaterThanOrEqual } from '../../util';
import { MutableRefObject } from 'react';
import { BryntumScheduler } from '@bryntum/scheduler-react';

export const isNotOutOfDate = (date: Date) => {
    return isDateGreaterThanOrEqual(date, new Date());
};

export const getToolTipHeader = (version: string, data: any, eventRecord?: any) => {
    if (data) {
        const name = data?.name;
        const equipmentType = data?.equipment ? `${data?.equipment?.equipmentType?.type ?? ''} #${data?.equipment?.number ?? ''}` : '';
        const dateRange = `${DateHelper.formatRange([new Date(eventRecord?.startDate), new Date(eventRecord?.endDate)], 'S{LT} - E{LT}')}`;

        if (version === 'order') {
            return `${name}<br/>${dateRange}<br/>${equipmentType}`;
        } else {
            var description = `${data?.name} (LI #${data?.orderLineItemNumber} - Order #${data?.orderNumber})`;
            var jobName = data?.jobName;
            var orderLineItemInformation = `${jobName ? `${jobName} - ` : ''}${data?.customerName} (Job #${data?.jobNumber ?? '???'})`;

            return `${description}<br/>${dateRange}<br/>${orderLineItemInformation}`;
        }
    }
    return '';
};

export const getHtml = (date: Date, data: any, schedulerRef: MutableRefObject<BryntumScheduler>, eventRecord?: any) => {
    let toolTip = `<div class="html-container">
                        <div class="flex-box">
                            ${getToolTipData(date, data, eventRecord)}
                        </div>
                        <div class="divider-vertical"></div>
                        <div class="flex-box">
                            ${getMemos(data, schedulerRef)}
                        </div>
                    </div>`;
    return toolTip;
};

const getMemos = (data: any, schedulerRef: MutableRefObject<BryntumScheduler>) => {
    const memoHtml = `<div class="memo-container">
                        <div class="memo-body">
                            <div class="memo-row">
                                <span class="memo-label">Dispatch/Billing Memo:</span>
                                <span class="memo-value">${data.dispatchBillingMemo ?? ''}</span>
                            </div>
                            <div class="divider"></div>
                            <div class="memo-row">
                                <span class="memo-label">Driver Memo:</span>
                                <span class="memo-value">${data.driverMemo ?? ''}</span>
                            </div>
                            <div class="divider"></div>
                            <div class="memo-row">
                                <span class="memo-label">Driver Comment:</span>
                                <span class="memo-value">${data.driverComment ?? ''}</span>
                            </div>
                        </div>
                    </div>`;
    return memoHtml;
};

const getToolTipData = (date: Date, data: any, eventRecord?: any) => {
    const convertMinsToHrsMins = (mins: number) => {
        let h = Math.floor(mins / 60);
        let m = mins % 60;
        let hours = h < 10 ? '0' + h : h;
        let minutes = m < 10 ? '0' + m : m;
        return `${hours}:${minutes}`;
    };

    let dispatchingIntervalTime = '';
    if (data?.dispatchingIntervalTime) {
        dispatchingIntervalTime = convertMinsToHrsMins(data.dispatchingIntervalTime!);
    }

    let status = '';
    if (eventRecord) {
        if (eventRecord?.isOrderInReview) {
            status = 'In Review';
        } else if (eventRecord?.isCompleted) {
            status = 'Complete';
        } else {
            status = eventRecord?.released ? 'Released' : 'Unreleased';
        }
    }

    const toolTipHtml = `<div class="tooltip-container">
                            <div class="tooltip-body">
                                <div class="tooltip-row">
                                    <span class="tooltip-label">Status:</span>
                                    <span class="tooltip-value">${status}</span>
                                </div>
                                <div class="tooltip-row">
                                    <span class="tooltip-label">Customer:</span>
                                    <span class="tooltip-value">${data?.customerName ?? ''}</span>
                                </div>
                                <div class="tooltip-row">
                                    <span class="tooltip-label">Orderer:</span>
                                    <span class="tooltip-value">${data?.orderer ?? ''}</span>
                                </div>
                                <div class="tooltip-row">
                                    <span class="tooltip-label">Project Name:</span>
                                    <span class="tooltip-value">${data?.projectName ?? ''}</span>
                                </div>
                                <div class="tooltip-row">
                                    <span class="tooltip-label">Job Name:</span>
                                    <span class="tooltip-value">${data?.jobName ?? ''}</span>
                                </div>
                                <div class="tooltip-row">
                                    <span class="tooltip-label">PO Number:</span>
                                    <span class="tooltip-value">${data?.poNumber ?? ''}</span>
                                </div>
                                <div class="tooltip-row">
                                    <span class="tooltip-label">Job Number:</span>
                                    <span class="tooltip-value">${data?.customerJobNumber ?? ''}</span>
                                </div>
                                <div class="tooltip-row">
                                    <div class="tooltip-row">
                                        <span class="tooltip-label">Order #:</span>
                                        <span class="tooltip-value">${data?.orderNumber ?? ''}</span>
                                    </div>
                                    <div class="tooltip-row">
                                        <span class="tooltip-label">Line Item #:</span>
                                        <span class="tooltip-value">${data?.orderLineItemNumber}</span>
                                    </div>
                                </div>
                                <div class="tooltip-row">
                                    <span class="tooltip-label">Contact:</span>
                                    <span class="tooltip-value">${data?.contactName ?? ''}</span>
                                </div>
                                <div class="tooltip-row">
                                    <span class="tooltip-label">Ordered By:</span>
                                    <span class="tooltip-value">${data?.orderedByContactName ?? ''}</span>
                                </div>
                                <div class="divider"></div>
                                <div class="tooltip-row">
                                    <span class="tooltip-label">Description:</span>
                                    <span class="tooltip-value">${data?.description ?? ''}</span>
                                </div>
                                <div class="tooltip-row">
                                    <span class="tooltip-label">Requirements:</span>
                                    <span class="tooltip-value">${data?.requirements ?? ''}</span>
                                </div>
                                <div class="tooltip-row">
                                    <span class="tooltip-label">Equipment Type:</span>
                                    <span class="tooltip-value">${data?.equipment?.equipmentType?.type ?? ''}</span>
                                </div>
                                <div class="divider"></div>
                                <div class="tooltip-row">
                                    <div class="tooltip-row">
                                        <span class="tooltip-label">Yard Time:</span>
                                        <span class="tooltip-value">${data?.yardTime ? new Date(data?.yardTime).toLocaleTimeString() : 'ASAP'}</span>
                                    </div>
                                    <div class="tooltip-row">
                                        <span class="tooltip-label">Onsite Time:</span>
                                        <span class="tooltip-value">${data?.startDate ? new Date(data?.startDate).toLocaleTimeString() : 'ASAP'}</span>
                                    </div>
                                </div>
                                <div class="tooltip-row">
                                    <span class="tooltip-label">Interval Time:</span>
                                    <span class="tooltip-value">${dispatchingIntervalTime}</span>
                                </div>
                                <div class="divider"></div>
                                <div class="tooltip-row">
                                    <span class="tooltip-label">Site:</span>
                                    <span class="tooltip-value">${data?.siteName ?? ''}</span>
                                </div>
                                <div class="tooltip-row">
                                    <span class="tooltip-label">Haul To:</span>
                                    <span class="tooltip-value">${data?.haulToAddressDispatchCard}</span>
                                </div>
                                <div class="tooltip-row">
                                    <span class="tooltip-label">Haul From:</span>
                                    <span class="tooltip-value">${data?.haulFromAddressDispatchCard}</span>
                                </div>
                            </div>
                        </div>`;

    return toolTipHtml;
};
